export interface Generation {
  generation: boolean;
}
